import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoFornecedorSchema } from '../types/ProdutoFornecedor';

type ProdutoComprasGetParams = Partial<
    DefaultApiParams & {
        fornecedor_idpk: number;
        compra_idpk: number;
    }
>;

type ProdutoComprasProps = {
    idpk?: number;
    params?: ProdutoComprasGetParams;
};

const schema = registrosSchema(ProdutoFornecedorSchema);

function apiProdutoCompras({ idpk, params }: ProdutoComprasProps) {
    return fetchApi({
        endpoint: 'Produto/Compras',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export function apiProdutoComprasQueryOptions({ idpk, params }: ProdutoComprasProps) {
    return queryOptions({
        queryFn: () => apiProdutoCompras({ idpk, params }),
        queryKey: ['apiProdutoCompras', idpk, params],
    });
}
